import { useCallback, useEffect } from 'react';

type IUseHandleKeyDown = (args: { isOpen: boolean; onClose: () => void }) => void;

export const useHandleKeyDown: IUseHandleKeyDown = ({ isOpen, onClose }) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);
};
